import {
  Addition,
  Address,
  Credentials,
  IsoCodes,
  Location,
  Position,
  Rectangle
} from '../General';

export enum OrderBy {
  NONE = 'NONE',
  BRANCHES_DISTANCE = 'BRANCHES_DISTANCE',
  CITY_CITYPART_DISTANCE = 'CITY_CITYPART_DISTANCE',
  COMPANY_NAME = 'COMPANY_NAME',
  COMPANYNAME_FIRSTNAME = 'COMPANYNAME_FIRSTNAME',
  DISTANCE = 'DISTANCE',
  DISTANCE_COMPANY_NAME = 'DISTANCE_COMPANY_NAME',
  FIRSTNAME_SIRNAME_ZIP = 'FIRSTNAME_SIRNAME_ZIP',
  MATRIX_COMPANY_NAME = 'MATRIX_COMPANY_NAME',
  MATRIX_DISTANCE = 'MATRIX_DISTANCE'
}

export interface SizeOrder {
  Top: number;
  OrderBy: OrderBy;
}

export interface Branches {
  Branches: string;
}

export interface Filter {
  MaxRadius: number;
  FreeFilter: string;
}

export interface Paging {
  Page: number;
}

export interface AdditionalData {
  AddressListPageSize?: number;
  CompanyFirstNameSingleWordsFilter?: string;
  LocXForDistanceCalculation?: number;
  LocYForDistanceCalculation?: number;
  MaximumNoOfRadiusExpansionSteps?: number;
  MinimumReturnCount?: number;
  CoordFormatIn?: 'GEODECIMAL_POINT';
  DataFilter?: string;
}

export interface SearchBranchesFull
  extends Credentials,
    IsoCodes,
    Branches,
    Filter,
    SizeOrder,
    Addition {}

export interface SearchBranchesCoordBasedAddressRequest
  extends SearchBranchesFull,
    Address,
    Paging {}

export interface SearchBranchesCoordBasedLocationRequest
  extends SearchBranchesFull,
    Location,
    Paging {}

export interface SearchBranchesCoordBasedPositionRequest
  extends SearchBranchesFull,
    Position,
    Paging {}

export interface SearchBranchesCoordBasedRectangleRequest
  extends SearchBranchesFull,
    Rectangle,
    Paging {}

export interface SearchBranchesCoordBasedMinimizedRequest
  extends Credentials,
    IsoCodes,
    Branches,
    Address {}

export interface SearchBranchesCountryWideRequest
  extends Credentials,
    IsoCodes,
    Branches,
    Filter,
    SizeOrder,
    Paging,
    Addition {}

export interface SearchBranchesCountryWideMinimizedRequest
  extends Credentials,
    IsoCodes,
    Branches {}

export interface SearchBranchesGlobalAddressRequest
  extends SearchBranchesFull,
    Address,
    Paging {}

export interface SearchBranchesGlobalPositionRequest
  extends SearchBranchesFull,
    Position,
    Paging {}

export interface SearchIdentifierBasedRequest
  extends Credentials,
    IsoCodes,
    Addition {
  Identifier: string;
}

export interface SearchBranchesClusterRequest extends SearchBranchesFull {
  ClusterID: string;
  ClusterLevel: string;
  ProductTypes: string;
}

export interface SearchBranchesTilesRequest
  extends Credentials,
    IsoCodes,
    Branches,
    Rectangle,
    SizeOrder,
    Paging,
    Addition {
  ZoomLevel: number;
  ClusterLevel: number;
  TilesSplitted: number;
}

export interface SearchBranchesTilesMinimizedRequest
  extends Credentials,
    IsoCodes,
    Branches,
    Rectangle {
  ZoomLevel: number;
  ClusterLevel: number;
}
